import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import AdvertisementStore from "../../stores/AdvertisementDetailsStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import ProfileStore from "../../stores/ProfileStore";
import AdvertisementDetailsView from "../views/AdvertisementDetailsView";
import LoadingView from "../views/LoadingView";
import AdvertisementDetailsPreviewView from "../views/AdvertisementDetailsPreviewView";

class AdvertisementDetailsContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "advertisementStore": AdvertisementStore.getState(),
            "profileState": ProfileStore.getState()
        }
    }

    componentDidMount() {
        this.advertisementStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.ADVERTISEMENT_STORE_UPDATE, this.handleStoreUpdate);
        this.profileStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PROFILE_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.ADVERTISEMENT_VIEW_MOUNTED, {"advertisementId" :this.props.match.params.id})
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.advertisementStoreSubscriber);
        EventPublisher.unsubscribe(this.profileStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "advertisementStore": AdvertisementStore.getState(),
            "profileState": ProfileStore.getState()
        });
    };

    render() {
        if (this.state.advertisementStore.loadingState === LoadingStates.INITIALIZED ||
            this.state.advertisementStore.loadingState === LoadingStates.LOADING) {
            return (
                <LoadingView titleText="Loading Advertisement"/>
            );
        }

        if (this.state.advertisementStore.advertisement.memberId !== this.state.profileState.memberId) {
            return this._renderOtherPersonsAdvertisementDetails();
        }

        return this._renderMyAdvertisementDetails();

    }

    _renderMyAdvertisementDetails() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div>
                                <AdvertisementDetailsPreviewView
                                    advertisementId={this.state.advertisementStore.advertisement.advertisementId}
                                    memberId={this.state.advertisementStore.advertisement.memberId}
                                    title={this.state.advertisementStore.advertisement.title}
                                    description={this.state.advertisementStore.advertisement.description}
                                    statusId={this.state.advertisementStore.advertisement.statusId}
                                    statusName={this.state.advertisementStore.advertisement.statusName}
                                    created={this.state.advertisementStore.advertisement.created}
                                    updated={this.state.advertisementStore.advertisement.updated}
                                    deleted={this.state.advertisementStore.advertisement.deleted}
                                    imageNames={this.state.advertisementStore.advertisement.imageNames}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _renderOtherPersonsAdvertisementDetails() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div>
                                <AdvertisementDetailsView
                                    advertisementId={this.state.advertisementStore.advertisement.advertisementId}
                                    memberId={this.state.advertisementStore.advertisement.memberId}
                                    title={this.state.advertisementStore.advertisement.title}
                                    description={this.state.advertisementStore.advertisement.description}
                                    statusId={this.state.advertisementStore.advertisement.statusId}
                                    statusName={this.state.advertisementStore.advertisement.statusName}
                                    created={this.state.advertisementStore.advertisement.created}
                                    updated={this.state.advertisementStore.advertisement.updated}
                                    deleted={this.state.advertisementStore.advertisement.deleted}
                                    imageNames={this.state.advertisementStore.advertisement.imageNames}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AdvertisementDetailsContainer;